// -- React Libraries
import React from 'react';

// -- Styles
import StyleWrapper from "./Wrapper";
import "../../../../fonts/font-awesome/css/all.css";

export default class ReviewBlock extends React.Component {
    constructor(props) {
        super(props);
        
        this.authorName = props.review.author.name.label;
        this.rating = parseInt(props.review["im:rating"].label);

        this.title = props.review.title.label;
        this.review = props.review.content.label;

        this.state = { isExpanded: props.isExpanded };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ isExpanded: nextProps.isExpanded });  
    }

    render() {
        {
            var starsComponent = Array.apply(null, Array(this.rating))
                .map( function (value, index) {
                    return (<i key={index} className="fa fa-star"></i>);
                }.bind(this));
        }

        return (
            <StyleWrapper className={this.props.className}>
                <div className="header-row">
                    <div className="rating-emoji">
                        {
                            this.rating >= 4 && (
                                <i className="far fa-smile"></i>
                            ) || (
                                <i className="far fa-meh"></i>
                            )
                        }
                    </div>

                    <div className="author">
                        <span>{this.authorName}</span>
                    </div>
                </div>
                
                <div className="title">{this.title}</div>

                <div className={`content ${this.state.isExpanded && "expanded" || "collapsed"}`}>
                    <p dangerouslySetInnerHTML={
                        {
                            __html: this.state.isExpanded &&
                                this.review.replace("\r\n", "<br /><br />").replace(/[\r\n]/gi, "<br /><br />") ||
                                this.review
                        }
                    }>
                    </p>
                </div>

                <div className="ratings">
                    {starsComponent}
                </div>
            </StyleWrapper>
        );
    }
};


// WEBPACK FOOTER //
// ./src/containers/AsoAnalytic/ScoreSummary/ReviewBlock/index.js